const DEFAULT_DUPLICATE_PATTERNS = [
  'Uniqueness violation',
  'Uniqueness',
  'already exists',
  'duplicate key value violates unique constraint'
]

const collectErrorMessages = (error) => {
  if (!error) return []

  if (Array.isArray(error)) {
    return error.flatMap(item => collectErrorMessages(item))
  }

  if (typeof error === 'string') {
    return [error]
  }

  const messages = []

  if (typeof error.message === 'string') {
    messages.push(error.message)
  }

  if (typeof error.toString === 'function') {
    const stringified = error.toString()
    if (stringified && stringified !== '[object Object]') {
      messages.push(stringified)
    }
  }

  return messages
}

export const hasDuplicateValidationError = (error, additionalPatterns = []) => {
  const patterns = [...DEFAULT_DUPLICATE_PATTERNS, ...additionalPatterns]
  const messages = collectErrorMessages(error)

  return messages.some(message => patterns.some(pattern => message.includes(pattern)))
}

export const getDuplicateValidationMessage = (fieldLabel) => `${fieldLabel} already exists.`
